import { AfterViewInit, Component, DOCUMENT, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiServiceService } from '../../../../modules/services/api-service.service';
import alertify from 'alertifyjs';
import { ApplicationDetails } from '../../approvals-landing/approvals-landing.model';
import { CharLength } from '../../../../modules/directives/char-length.directive';

@Component({
  selector: 'app-approval-or-query-modal',
  imports: [ReactiveFormsModule, CharLength],
  templateUrl: './approval-or-query-modal.html',
  styleUrl: './approval-or-query-modal.scss',
})
export class ApprovalOrQueryModal implements OnInit, AfterViewInit, OnDestroy, OnChanges{
  @Input() mode: "APPROVE" | "QUERY" = "APPROVE"; 
  @Input() isOpen = false;
  @Input() applicationDetails: ApplicationDetails;
  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();

  isSubmitting: boolean;
  isEditingStep: boolean;
  isLoadingSteps: boolean;
  form!: FormGroup;
  selectedStepIndex: number;

  modifiedPaymentAmount: boolean = false;

  stepNumbers = Array.from({length: 10}, (_, i) => i + 1);

  actions = [
    { value: 'NEXT', label: 'NEXT' },
    { value: 'FINAL', label: 'FINAL' },
  ];

  private readonly hostElement: HTMLElement;

  constructor(
    private fb: FormBuilder,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document,
    private apiService:ApiServiceService
  ) {
    this.hostElement = this.elementRef.nativeElement;
  }
  

  ngAfterViewInit(): void {
    this.renderer.appendChild(this.document.body, this.hostElement);
  }

  ngOnDestroy(): void {
    if (this.hostElement.parentNode === this.document.body) {
      this.renderer.removeChild(this.document.body, this.hostElement);
    }
  }

  ngOnInit(): void {
    this.initializeForms();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
    // const updateApplicationDetails = changes['applicationDetails'];

    // if (updateApplicationDetails.firstChange) {
    //   const changes = updateApplicationDetails.firstChange;
    //   this.form.controls['paymentAmount'].setValue(changes)
    // }
  }

  initializeForms() {
    this.form = this.fb.group({
      paymentAmount: [{value: this.applicationDetails.overview.paymentAmount ?? 0, disabled: true}, [Validators.required]],
      comment: ['', []]
    });
  }

  modifyPaymentAmount() {
    this.modifiedPaymentAmount = true;
    this.form.controls['paymentAmount'].enable();
  }

  exitPaymentAmountModification() {
    this.modifiedPaymentAmount = false;
    this.form.controls['paymentAmount'].setValue(this.applicationDetails?.overview?.paymentAmount);
    this.form.controls['paymentAmount'].disable();
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.form.disable();

    if (this.mode === "APPROVE") {
      const payload = {
        ...this.form.value,
        applicationId: this.applicationDetails.metaData.applicationId,
        action: "APPROVE"
      };
      this.apiService.post('/approve/application', payload).subscribe({
        next: (response: { message?: string }) => {
          this.submitted.emit();
          this.close();
          this.isSubmitting = false;
          alertify.success(response.message || 'Workflow approved successfully.');
        },
        error: (error) => {
          const message =
            typeof error === 'string'
              ? error
              : 'Unable to approve workflow. Please try again.';

          this.isSubmitting = false;
          alertify.error(message);
        }
      })
    } else if (this.mode === "QUERY") {
      const payload = {
        ...this.form.value,
        applicationId: this.applicationDetails.metaData.applicationId,
        action: "QUERY"
      };
      this.apiService.post('/approve/application', payload).subscribe({
        next: (response: { message?: string }) => {
          this.submitted.emit();
          this.close();
          this.isSubmitting = false;
          alertify.success(response.message || 'Workflow queried successfully.');
        },
        error: (error) => {
          const message =
            typeof error === 'string'
              ? error
              : 'Unable to query workflow. Please try again.';

          this.isSubmitting = false;
          alertify.error(message);
        }
      })

    }
  }

  close(): void {
    this.closed.emit();
    this.form.reset();
  }
}
